import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components/macro";

import Form from "./sign in components/Form";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

function SignIn() {
  return (
    <Wrapper>
      <Helmet title="Sign In" />

      <Form />
    </Wrapper>
  );
}

export default SignIn;
